import { StepLayout } from './StepLayout';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import I18n from 'I18n';
import { useDispatch } from 'react-redux';
import { UsageTrackerUtils } from 'feature-unboxing-common';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import useChatSlice from '../hooks/useChatSlice';
import { useEffect } from 'react';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { NextButton } from './Wizard/NextButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  TrackerActions
} = UsageTrackerUtils;
export default function SecondStep({
  step,
  onNext
}) {
  const dispatch = useDispatch();
  const {
    chat: {
      customChatName,
      welcomeMessage
    },
    set
  } = useChatSlice();
  useEffect(() => {
    dispatch(TrackerActions.trackPageView({
      screen: 'second-step'
    }));
  }, [dispatch]);
  return /*#__PURE__*/_jsxs(StepLayout, {
    step: 2,
    i18nKey: "secondStep",
    children: [/*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.secondStep.chatHeading"
        }), /*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.secondStep.chatHeadingTooltip"
          }),
          marginInlineStart: "100"
        })]
      }),
      children: /*#__PURE__*/_jsx(TextInput, {
        name: "customChatName",
        placeholder: I18n.text('app.secondStep.chatHeadingPlaceholder'),
        value: customChatName,
        onChange: e => set({
          customChatName: e.currentTarget.value
        }),
        "data-test-id": "custom-chat-name-input"
      })
    }), /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.secondStep.welcomeMessage"
        }), /*#__PURE__*/_jsx(HelpIcon, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.secondStep.welcomeMessageTooltip"
          }),
          marginInlineStart: "100"
        })]
      }),
      children: /*#__PURE__*/_jsx(TextArea, {
        use: "on-dark",
        name: "welcomeMessage",
        rows: 3,
        placeholder: I18n.text('app.secondStep.welcomeMessagePlaceholder'),
        value: welcomeMessage,
        onChange: e => set({
          welcomeMessage: e.currentTarget.value
        }),
        "data-test-id": "welcome-message-input"
      })
    }), /*#__PURE__*/_jsx(NextButton, {
      step: step,
      onClick: onNext
    })]
  });
}